import React, { useState } from "react";
import useStyles from "./styles";
import IconGraph from "Assets/images/graph-blue.svg";
import IconGraphOrange from "Assets/images/graph-orange.svg";
import IconList from "Assets/images/list-blue.svg";
import IconListOrange from "Assets/images/list-orange.svg";
import { Tooltip } from "@mui/material";

const ToggleWithIcon = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState(false);
  const handleChange = () => {
    setValue(!value);
    props.onChange(value);
  };
  return (
    <div className={classes.root}>
      <label className={classes.reactSwitch}>
        <input
          data-testid="handleChange"
          checked={value}
          onChange={() => handleChange()}
          className={classes.reactSwitchCheckBox}
          type="checkbox"
        />
        <div className={classes.reactSwitchBtn} />
        <div className={`${classes.reactSwitchLabel}`}>
          <span>
            {value ? (
              <Tooltip title="Graph view">
                <img src={IconGraph} alt="graph view" />
              </Tooltip>
            ) : (
              <Tooltip title="Graph view">
                <img src={IconGraphOrange} alt="graph view" />
              </Tooltip>
            )}
          </span>
          <span>
            {!value ? (
              <Tooltip title="List view">
                <img src={IconList} alt="list view" />
              </Tooltip>
            ) : (
              <Tooltip title="List view">
                <img src={IconListOrange} alt="list view" />
              </Tooltip>
            )}
          </span>
        </div>
      </label>
    </div>
  );
};

export default ToggleWithIcon;
